import {ReactNode} from 'react';
import {view, css} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';

type Props = {
  children: ReactNode;
  hover?: boolean;
  isOuter?: boolean;
  customStyles?: Record<string, any>;
};

export function LightCard({children, hover, isOuter, customStyles}: Props) {
  const theme = useTheme();

  const defaultBorderRadius = isOuter ? 'medium' : 'xsmall'; // Currently used for stripe audience
  const finalBorderRadius = theme.cardBorderRadius
    ? css.value(theme.cardBorderRadius)
    : defaultBorderRadius;

  const defaultHoverBoxShadow = css.value(
    '0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(48, 49, 61, 0.08)',
  ); // Currently used for stripe audience
  const finalHoverBoxShadow = theme.hoverBoxShadow
    ? css.value(theme.hoverBoxShadow)
    : defaultHoverBoxShadow;

  const cardStyles = css({
    backgroundColor: 'surface',
    border: css.value('1px solid #D8DEE4'),
    borderRadius: finalBorderRadius,
    boxShadow: 'base',
    padding: css.value('$space.200'),
    marginBottom: 'small',
  });

  const outerStyles = css({
    boxShadow: 'none',
  });

  // duplicating tokens.shadow.large due to deprecated Sail version
  const hoverStyles = css({
    '&:hover': {
      boxShadow: finalHoverBoxShadow,
    },
  });

  const styles = [cardStyles];

  if (hover) {
    styles.push(hoverStyles);
  }

  if (isOuter) {
    styles.push(outerStyles);
  }

  if (customStyles) {
    styles.push(css(customStyles));
  }

  return (
    <view.div
      data-testid="card"
      uses={styles}
      css={{
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
    >
      {children}
    </view.div>
  );
}
